/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_State_GrantedInputs */

const en_consent_state_granted = /** @type {(inputs: Consent_State_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current choice: analytics accepted.`)
};

/**
* | output |
* | --- |
* | "Your current choice: analytics accepted." |
*
* @param {Consent_State_GrantedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_state_granted = /** @type {((inputs?: Consent_State_GrantedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_State_GrantedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_state_granted(inputs)
});